import { OnboardingStatus } from '@Store/index';
import { AuthUserOnboardingStatus } from '@Store/slices/authOnboarding/authOnboarding.types';

/**
 * Terminal KYC/KYB failure statuses (backend `OnboardingStatus.isDeclined()`).
 * These customers have no way to continue onboarding and are always routed to the
 * KYC failed page. The login API may return their profile without an access token.
 */
const DECLINED_ONBOARDING_STATUSES: readonly OnboardingStatus[] = [
  OnboardingStatus.KYB_FAILED_FINAL,
  OnboardingStatus.KYC_FAILED_FINAL,
  OnboardingStatus.KYC_FAILED_PARTNER,
];

export const isDeclinedOnboardingStatus = (status?: OnboardingStatus) =>
  status !== undefined && DECLINED_ONBOARDING_STATUSES.includes(status);

/**
 * Terminal authorized-user KYC failure statuses. The auth user onboarding GET can return
 * these, meaning the authorized user has no way to continue and must land on the
 * verification failed screen (same destination as a rejected DocV).
 */
const DECLINED_AUTHORIZED_USER_ONBOARDING_STATUSES: readonly AuthUserOnboardingStatus[] = [
  AuthUserOnboardingStatus.KYC_FAILED_FINAL,
];

export const isDeclinedAuthorizedUserOnboardingStatus = (status?: AuthUserOnboardingStatus) =>
  status !== undefined && DECLINED_AUTHORIZED_USER_ONBOARDING_STATUSES.includes(status);
